import { TaskDashboard } from 'modules/task';
import { CatalogDashboard } from 'modules/product';
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import WelcomeBanner from "./WelcomeBanner";
import WidgetColorNumber from "./widgets/WidgetColorNumber";
import { useEffect, useState } from "react";
import WidgetHistoryNumber from "./widgets/WidgetHistoryNumber"; 
import "assets/css/Dashboard.css";
import * as apiLeads from "api/apiLeads";
import vconst from "utils/helpers/structs/vconst";
import { useToast } from "context/ToastContext";
import { useAuth } from "context/AuthContext";
import { hasUserAccess } from "utils/helpers/access/hasUserAccess";
import SolarIcon from 'components/icons/SolarIcon';

const _db = {
    leadNew : 10,
    leadProcess : 15,
    leadNeedProp : 3,
    leadExecProp : 2
}
 
const Dashboard = () => {

    const { t } = useTranslation(['Dashboard']);
    const { auth } = useAuth();
    const canViewReports = hasUserAccess(auth?.user, 'reportsView');
    const [ state, setState ] = useState(null);
    const [ leadsAll, setLeadsAll ] = useState(null);
    const [ leadsReject, setLeadsReject ] = useState(null);
    const [ objectCreated, setObjectCreated ] = useState(null);
    const [ objectIncome, setObjectIncome ] = useState(null);

    const { showToast } = useToast();
 
    const fetchCounter = async () => {
        const resCounter = await apiLeads.getCounter();
    console.log(resCounter);
        if (!resCounter) return showToast(t('common:messError'),'danger');
        setState(resCounter.counter);
        setLeadsAll(resCounter?.leads?.all);
        setLeadsReject(resCounter?.leads?.rejects);
        setObjectCreated(resCounter?.objects?.created)
        setObjectIncome(resCounter?.objects?.income);
    }

    useEffect(()=>{
        fetchCounter();
        
    },[]);
 
    return (
        <> 
        <Row>
            <Col sm={12} className="pt-2">
                <WelcomeBanner />
                <div className="pb-4">
                    <Row>
                        <WidgetColorNumber 
                            variant="danger"
                            iconJsx={(<SolarIcon name="file-earmark-plus" />)}
                            infoNum={Array.isArray(state) ? state?.find(c=>c.leadStatus === vconst.leadNew)?.CNT||'-' : '-'}
                            infoText={t('leadStatus.new')}/> 

                        <WidgetColorNumber 
                            variant="info"
                            iconJsx={(<SolarIcon name="card-checklist" />)}
                            infoNum={Array.isArray(state) ? state?.find(c=>c.leadStatus === vconst.leadInWoork)?.CNT||'-' : '-'}
                            infoText={t('leadStatus.process')}/>

                        <WidgetColorNumber 
                            variant="warning"
                            iconJsx={(<SolarIcon name="file-earmark-text" />)}
                            infoNum={Array.isArray(state) ? state?.find(c=>c.leadStatus === vconst.leadNeedOffer)?.CNT||'-' : '-'}
                            infoText={t('leadStatus.needProp')}/>

                        <WidgetColorNumber 
                            variant="primary"
                            iconJsx={(<SolarIcon name="file-earmark-check" />)}
                            infoNum={Array.isArray(state) ? state?.find(c=>c.leadStatus === vconst.leadOffer)?.CNT||'-' : '-'}
                            infoText={t('leadStatus.execProp')}/>


                        <WidgetHistoryNumber
                            aHistory={leadsAll}
                            variant="danger"
                            infoText={t('statInfo.allLeads')}
                            iconJsx={(<SolarIcon name="file-earmark-plus" />)}/>


                        <WidgetHistoryNumber
                            aHistory={leadsReject}
                            variant="secondary"
                            infoText={t('statInfo.allReject')}
                            iconJsx={(<SolarIcon name="person-x" />)}/>

                        {canViewReports && (<>
                        <WidgetHistoryNumber
                            aHistory={objectCreated}
                            variant="success"
                            infoText={t('statInfo.allObject')}
                            iconJsx={(<SolarIcon name="building" />)}/>


                        <WidgetHistoryNumber
                            aHistory={objectIncome}
                            priceMode={true}
                            variant="info"
                            infoText={t('statInfo.income')}
                            iconJsx={(<SolarIcon name="graph-up-arrow" />)}/>
                        </>)}

                    </Row>
                    <Row className="g-3">
                        <TaskDashboard />
                        <CatalogDashboard />
                    </Row>
                </div>
            </Col>
        </Row>
        </>
    ) 
}

export default Dashboard;